import React from "react";

/**
 * FlexibleControl
 * - Monitor: نمایش تگ‌ها از latestTags
 * - Buttons: دکمه‌های دیجیتال نامحدود (هر دکمه => onCommand(tag, value))
 *
 * props:
 *  title: string
 *  latestTags: [{tag_name, last_value, ...}]
 *  monitorItems: [{ label, tag }]
 *  buttons: [{ label, tag, value }]
 *  onCommand: (tagName, value) => void
 */
const FlexibleControl = ({
  title,
  latestTags,
  monitorItems = [],
  buttons = [],
  onCommand,
}) => {
  const getValue = (tagName) => {
    const t = latestTags.find((x) => x.tag_name === tagName);
    return t ? t.last_value : "N/A";
  };

  return (
    <div className="box">
      <h3>{title}</h3>

      {/* ===== Monitor ===== */}
      {monitorItems.map((item, i) => (
        <p key={i}>
          {item.label}: <strong>{getValue(item.tag)}</strong>
        </p>
      ))}

      {/* ===== Buttons ===== */}
      <div className="button-group">
        {buttons.map((btn, i) => (
          <button key={i} onClick={() => onCommand(btn.tag, btn.value)}>
            {btn.label}
          </button>
        ))}
      </div>
    </div>
  );
};

export default FlexibleControl;
